export default __webpack_public_path__ + "images/icon.svg?0bdc3967938b15932aa327fa0f8b3e37";